import { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import axiosInstance from '@/services/api/axios';

export default function PayoutReceiptButton({ payoutId, hasReceipt }: { payoutId: string; hasReceipt: boolean }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [preview, setPreview] = useState<{ url: string; pdf: boolean } | null>(null);
  const requestId = useRef(0);

  useEffect(() => () => { if (preview) URL.revokeObjectURL(preview.url); }, [preview]);
  useEffect(() => () => { requestId.current += 1; }, []);

  const close = () => {
    requestId.current += 1;
    setOpen(false);
    setPreview(null);
  };
  const view = async () => {
    const currentRequest = ++requestId.current;
    setOpen(true);
    setLoading(true);
    setError(false);
    try {
      const { data } = await axiosInstance.get<Blob>(`/payouts/invoices/${payoutId}/receipt`, { responseType: 'blob' });
      if (currentRequest === requestId.current) {
        setPreview({ url: URL.createObjectURL(data), pdf: data.type.includes('application/pdf') });
      }
    } catch {
      if (currentRequest === requestId.current) setError(true);
    } finally {
      if (currentRequest === requestId.current) setLoading(false);
    }
  };

  if (!hasReceipt) return <>—</>;
  return <>
    <Button size="small" variant="outlined" onClick={() => void view()}>Чек</Button>
    <Dialog open={open} onClose={close} fullWidth maxWidth="md">
      <DialogTitle>Чек выплаты</DialogTitle>
      <DialogContent>
        {loading && <CircularProgress />}
        {error && <Alert severity="error">Не удалось загрузить чек. Закройте окно и повторите попытку.</Alert>}
        {preview && (preview.pdf
          ? <Box component="iframe" src={preview.url} title="Чек выплаты PDF" sx={{ width: '100%', height: '70vh', border: 0 }} />
          : <Box component="img" src={preview.url} alt="Чек выплаты" sx={{ display: 'block', maxWidth: '100%', maxHeight: '70vh', mx: 'auto' }} />)}
      </DialogContent>
      <DialogActions>
        {preview && <Button component="a" href={preview.url} download={`receipt-${payoutId}${preview.pdf ? '.pdf' : ''}`}>Скачать</Button>}
        <Button onClick={close}>Закрыть</Button>
      </DialogActions>
    </Dialog>
  </>;
}
